import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { MainModal } from "../../../components/modal/MainModal";
import { useError } from "../hooks/useError";
import { actionCreators } from "../redux/goalsSagas";
import FilterDropdown from "./FilterDropdown";
import { usePopup } from "../../../hooks/usePopup";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { ErrorList } from "../../../components/ErrorList";

const AddStaffModal = ({ goalType, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { isModalLoading, selectedFilters } = useSelector((state) => state.goals.addStaffModal);
  const singleLocation = useSelector((state) => state.goals.currentUser.singleLocation);
  const [goal, setGoal] = useState(2);
  const close = () => {
    dispatch(actionCreators.resetFilters());
    onClose();
  };

  useEffect(() => {
    dispatch(actionCreators.getModalFilters({ goalType }));
  }, []);

  const { errors, status } = useError(close);
  const save = () => {
    dispatch(actionCreators.createGoal({ goal, goalType }));
  };

  const onInputChange = (e) => {
    if (e.target.value > 100) return setGoal(100);
    if (e.target.value < -20) return setGoal(-20);
    setGoal(e.target.value);
  };

  const needToSelectDropdown = singleLocation
    ? ["goals", "staffs"]
    : ["divisions", "districts", "stores", "goals", "staffs"];

  const primaryButtonDisabled = !(
    needToSelectDropdown.every((key) => selectedFilters[key] && selectedFilters[key].length) &&
    (goal || goal === 0) &&
    status !== "pending"
  );

  return (
    <MainModal
      isOpen={isOpen}
      onClose={close}
      parentSelector=".goals-module"
      primaryButtonText="Submit"
      containerClassName="add-goals"
      primaryBtnHandler={save}
      primaryButtonDisabled={primaryButtonDisabled}
      secondaryBtnText="Cancel"
      secondaryBtnHandler={close}
      width={650}
      isLoading={isModalLoading}
      height={singleLocation ? "300px" : "360px"}
      headerCloseHandler={close}
      headerText="Add Staff"
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {status === "pending" ? (
          <LoadingAnimation text="Adding Goal(s)" height={singleLocation ? "140px" : "205px"} />
        ) : (
          <>
            {!singleLocation && (
              <div style={{ display: "flex", gap: "10px" }}>
                <FilterDropdown
                  filterKey="divisions"
                  name="Divisions"
                  includeFilter
                  goalType={goalType}
                  maxSelect={1}
                />
                <FilterDropdown
                  filterKey="districts"
                  name="Districts"
                  includeFilter
                  goalType={goalType}
                  maxSelect={1}
                />
                <FilterDropdown
                  filterKey="stores"
                  name="Locations"
                  includeFilter
                  goalType={goalType}
                  maxSelect={10}
                  avoidSelectIfMaxSelected
                  enableOnly
                />
              </div>
            )}

            <div style={{ display: "flex", gap: "10px" }}>
              <FilterDropdown
                filterKey="goals"
                name="Goals"
                includeFilter
                maxSelect={1}
                goalType={goalType}
                valueKey="class_name"
                labelKey="description"
              />
              <FilterDropdown
                filterKey="staffs"
                name="Staff"
                enableOnly
                includeFilter
                goalType={goalType}
                includeSelectAll
                valueKey="staff_uid"
                labelKey="name"
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p>Goal (%)</p>
                <input
                  className="manual-enter-number"
                  type="number"
                  value={goal}
                  onChange={onInputChange}
                  placeholder="2%"
                  min="-20"
                  max="100"
                />
              </div>
            </div>
          </>
        )}
      </div>
      <ErrorList errors={errors} />
    </MainModal>
  );
};

export const AddStaff = ({ goalType }) => {
  const { popup, openPopup, closePopup } = usePopup(["add", "edit", "delete"]);
  return (
    <>
      <button className="add-staff-button" title="Add Staff" onClick={() => openPopup("addStaff")}>
        Add Staff
      </button>
      {popup.addStaff && (
        <AddStaffModal
          goalType={goalType}
          isOpen={popup.addStaff}
          onClose={closePopup("addStaff")}
        />
      )}
    </>
  );
};
